<template>
  <a
    v-if="isExternalLink"
    v-bind="$attrs"
    :href="disabled ? '#' : to"
    target="_blank"
    :class="{ 'disabled': disabled }"
  >
    <slot />
  </a>

  <RouterLink
    v-else
    v-slot="{ href, navigate, isActive, isExactActive }"
    v-bind="$props"
    :replace="replace"
    custom
  >
    <a
      v-if="disabled"
      v-bind="$attrs"
      :class="{ 'disabled': disabled, 'router-link-active': isActive, 'router-link-exact-active': isExactActive }"
    >
      <slot />
    </a>

    <a
      v-else
      v-bind="$attrs"
      :href="href"
      :class="{ 'router-link-active': isActive, 'router-link-exact-active': isExactActive }"
      @click="navigate"
    >
      <slot />
    </a>
  </RouterLink>
</template>

<script setup>
import { computed } from 'vue';
import { RouterLink } from 'vue-router';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  ...RouterLink.props,
  disabled: Boolean,
  processing: Boolean,
  replace: Boolean,
  target: {
    type: String,
    default: 'self',
  },
});

const isExternalLink = computed(() => {
  return typeof props.to === 'string' && props.to.startsWith('http');
});

</script>
